import React from 'react';
import cvImg from '../../images/cv-img.png';
import './Resume.css';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import FavoriteIcon from '@material-ui/icons/Favorite';
import { Divider } from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import VisibilityIcon from '@material-ui/icons/Visibility';
import CastForEducationIcon from '@material-ui/icons/CastForEducation';
import WebIcon from '@material-ui/icons/Web';
import LanguageIcon from '@material-ui/icons/Language';
import PaymentIcon from '@material-ui/icons/Payment';
import VideoLibraryIcon from '@material-ui/icons/VideoLibrary';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    
  },
}));


const Resume = () => {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
  
    const handleChange = (event, newValue) => {
      setValue(newValue);
    };

    return (
        <div className="container mb-5 pb-5">
            <div className="row d-flex justify-content-center" style={{overflowX: 'hidden'}}>
                <div className="col-11 col-lg-5 d-flex justify-content-center align-items-center mt-2" data-aos="zoom-in">
                    <div className="personal-img">
                        <img src={cvImg} alt="cv" className="img-fluid cv-img"/>
                    </div>
                </div>
                <div className="col-lg-1"></div>
                <div className="col-11 col-lg-6 about-info">
                    <h2 className="mb-3">About Me</h2>
                    <p className="small-description">
                        Dynamic and detail-oriented Front-end Developer with a skill for user-friendly, solution effectively. Experience with pixel-perfect web design, clean code, and a fully modern website for going beyond web technology. I have an extensive understanding of end-to-end Front-end technology.
                    </p>

                    <div>
                        <div className={classes.root} id="tabs-bg">
                            <AppBar position="static" id="tab-bar" className="d-flex align-items-center">
                                <Tabs value={value} onChange={handleChange} indicatorColor="secondary"
                                    textColor="secondary" aria-label="simple tabs example">
                                    <Tab icon={<VisibilityIcon />} label="Main Skills" {...a11yProps(0)} className="tab-item"/>
                                    <Tab icon={<FavoriteIcon />} label="Experience" {...a11yProps(1)} className="tab-item"/>
                                     <Tab icon={<CastForEducationIcon />} label="Education" {...a11yProps(2)} className="tab-item"/>
                                </Tabs>
                            </AppBar>
                            <TabPanel value={value} index={0}>
                                <Typography variant="h5"style={{fontSize: "25px"}}>
                                    Skills
                                </Typography>
                                <Divider />
                                <List component="nav" aria-labelledby="nested-list-subheader"
                               className={classes.root}>
                                    <ListItem button>
                                        <ListItemIcon>
                                            <WebIcon className="text-white"/>
                                        </ListItemIcon>
                                        <ListItemText primary="Front-end Development" />
                                    </ListItem>
                                    <ListItem button>
                                        <ListItemIcon>
                                            <LanguageIcon className="text-white" />
                                        </ListItemIcon>
                                        <ListItemText primary="Backend Development" />
                                    </ListItem>
                                    <ListItem button>
                                        <ListItemIcon>
                                            <PaymentIcon className="text-white" />
                                        </ListItemIcon>
                                        <ListItemText primary="Payment Module Integration" />
                                    </ListItem>
                                    <ListItem button>
                                        <ListItemIcon>
                                            <VideoLibraryIcon className="text-white"/>
                                        </ListItemIcon>
                                        <ListItemText primary="Technical Video Maker" />
                                    </ListItem>
                                </List>
                            </TabPanel>



                            <TabPanel value={value} index={1}>
                                <Typography variant="h5" style={{marginBottom: "0.7rem", fontSize: "25px"}}>
                                    Development of a Web-Based Business Networking Platform.
                                </Typography>
                                <Typography variant="body2" color="textSecondary" component="p">
                                    <a href="https://businesstoglobe.com/" className="experience-sec" target="_blank" rel="noreferrer">
                                        Final Year Project
                                    </a>
                                </Typography>
                                <Typography variant="body2" color="textSecondary" component="p" style={{marginTop: "0.4rem",marginBottom: "0.3rem"}} >
                                    June 2020 - September 2020 - 4 months
                                </Typography>
                                <Divider />
                            </TabPanel>

                            <TabPanel value={value} index={2}>
                                <Typography variant="h5" style={{marginBottom: "0.7rem", fontSize: "25px"}}>
                                    Daffodil International University-DIU
                                </Typography>
                                <Typography variant="h6" style={{fontSize: "16px"}}>
                                    Graduate, Computer Science and Engineering
                                </Typography>
                                <Typography variant="h6"  style={{fontSize: "16px"}}>
                                    CGPA - 3.21
                                </Typography>
                                <Typography variant="h6"  style={{fontSize: "16px", marginBottom: "0.3rem"}}>
                                    2017 - 2020
                                </Typography>
                                <Divider />
                            </TabPanel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Resume;